import { DoctorProfileCard } from "@aph/ui-lib-humanx";
import React from "react";
import { useRouter } from "next/navigation";
import IconLeft from "$/icons/icon-left.svg";
import IconRight from "$/icons/icon-right.svg";
import { readableParam } from "@/components/DoctorsWidget/helpers";
import Slider, { Slide } from "@/components/Slider";
import { DeviceInfo } from "@/interface/deviceInfo";
import { NEXT_PUBLIC_PATIENT_BASE_URL } from "@/libs/constants/auth";
import { APOLLO_DOCTOR_TYPES, SMALL_DOCTOR_TAG_URL } from "@/components/DoctorsWidget/constants";
import styles from "./DoctorCardsList.module.scss";

interface DoctorCardsListInterface {
  doctors: any[];
  userAgent: DeviceInfo;
  logoUrl?: string;
  utm_medium?: string;
}

function DoctorCardsList(props: DoctorCardsListInterface) {
  const { doctors, userAgent, logoUrl, utm_medium } = props;
  const router = useRouter();

  const handleNavigationToDoctorDetail = (docValue: string, doctorId: string) => {
    const modifiedDoctorValue: string =
      readableParam(docValue)?.substring(0, 3) !== "dr-" ? readableParam("dr-" + docValue) : readableParam(docValue);

    return `/doctors/${modifiedDoctorValue}-${doctorId}?utm_source=momverse&utm_medium=${utm_medium}`;
  };

  const handleDoctorClick = (props: { name: string; id: string }) => {
    const { name, id } = props;
    const doctorEndpoint = handleNavigationToDoctorDetail(name, id);
    const fullUrl = `${NEXT_PUBLIC_PATIENT_BASE_URL}${doctorEndpoint}`;

    return fullUrl;
  };

  return (
    <>
      {doctors?.length > 0 ? (
        <div className={styles.slidercontainer}>
          <Slider
            dotsWrapperClass={styles.dotsWrapperClass}
            dotClass={styles.dotClass}
            slidesToShow={userAgent?.isDesktop ? 3 : 1}
            dotClassActive={styles.dotClassActive}
            center={!userAgent?.isDesktop}
            showDots={userAgent?.isMobile ? true : false}
            columnGap={20}
            autoplay={false}
            showArrows={userAgent?.isDesktop}
            nextArrow={<IconRight className={`${styles.arrows} ${styles.arrowNext}`} />}
            prevArrow={<IconLeft className={`${styles.arrows} ${styles.arrowPrev}`} />}
          >
            {doctors.map((doctor: any, index) => {
              const buttons = doctor?.buttons?.map((button: any) => ({
                button_title: button?.button_title,
                button_type: button?.button_type,
              }));
              const doctorProfileUrl = handleDoctorClick({ name: doctor?.displayName, id: doctor?.id });

              return (
                <React.Fragment key={`card-${doctor?.id}`}>
                  <Slide key={doctor?.id} index={index} className={styles.doctorCardSlide}>
                    <DoctorProfileCard
                      image={doctor?.photoUrl}
                      name={doctor?.displayName}
                      specialty={doctor?.specialtydisplayName}
                      experience={`${doctor?.experience} ${doctor?.experience > 1 ? `years` : `year`}`}
                      education={doctor?.qualification}
                      location={doctor?.doctorfacility}
                      btnOptions={buttons}
                      doctorTag={APOLLO_DOCTOR_TYPES.includes(doctor?.doctorType) ? SMALL_DOCTOR_TAG_URL : ``}
                      label={doctor?.displayName}
                      mrp={doctor?.onlineConsultationFees}
                      personLink={doctorProfileUrl}
                      onCtaClick={() => router.push(doctorProfileUrl)}
                      isMomverse={true}
                    />
                  </Slide>
                </React.Fragment>
              );
            })}
          </Slider>
        </div>
      ) : null}
    </>
  );
}

export default DoctorCardsList;
